module.exports = __webpack_public_path__ + "static/img/index_btn_1.1df6c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_btn_1.png
// module id = oLr1
// module chunks = 1